// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"CompanySearchInput_inputWrapper__N4jaM","input":"CompanySearchInput_input__4aYbz","red":"CompanySearchInput_red__xK9Z2","grey":"CompanySearchInput_grey__sOFd0"};